import * as React from 'react';
import { IAPanel } from '../../../../panels/Panel';
import { IATextField } from '../../../../textField/TextField';
import * as styles from "./Panel.css";
import { IAButton } from '../../../../button/Button';
import { LocalizationService } from '../../../../../services/LocalizationService';

export interface IGroupHeaderEditPanelProps {
  title: string;
  highlightColor: string;
  onClose: () => void;
  onSave: (newTitle: string) => void;
}

export interface IGroupHeaderEditPanelState {
  newTitle: string;
}

export default class GroupHeaderEditPanel extends React.Component<IGroupHeaderEditPanelProps, IGroupHeaderEditPanelState> {

  constructor(props, state) {
    super(props, state);
    this.state = {
      newTitle: undefined
    }
  }

  public componentWillReceiveProps(props: IGroupHeaderEditPanelProps): void {
    if (props.title !== this.props.title) {
      this.setState({ newTitle: props.title });
    }
  }

  private onClose(): void {
    this.props.onClose();
    document.body.style.height = "inherit";
    document.body.style.overflowY = "auto";
  }

  public render(): JSX.Element {
    return (
      <div>
        <IAPanel
          showNavigationBar={true}
          open={this.props.title != undefined}
          transition={"slide"}
          width={550}
          isMobile={false}
          close={() => this.onClose()}
        >
          <div className={styles.IA_viewPanelContentWrapper}>
            <IATextField
              label={new LocalizationService().strings.TargetingAdmin_UserGroup_EditPanel_Title}
              text={this.state.newTitle}
              borderRadius={5}
              toolTipText={new LocalizationService().strings.TargetingAdmin_ColoumName}
              placeholder={new LocalizationService().strings.TargetingAdmin_UserGroup_EditPanel_Title}
              onChange={(newTitle: string) => {
                this.setState({ newTitle });
              }}
            />
            <div style={{ float: 'left', position: 'absolute', bottom: '0', marginBottom: '20px' }}>
              <IAButton
                style={{ float: 'left' }}
                borderRadius={5}
                buttonColor={this.props.highlightColor}
                label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSave}
                disbaled={false}
                onClick={() => {
                  document.body.style.height = "inherit";
                  document.body.style.overflowY = "auto";
                  this.props.onSave(this.state.newTitle);
                }}
              />
              <IAButton
                label={new LocalizationService().strings.TargetingAdmin_PropertyPanelCancel}
                buttonColor={"#999999"}
                borderRadius={5}
                style={{ marginLeft: "10px", float: 'right' }}
                onClick={() => {
                  this.onClose();
                }}
              />
            </div>
          </div>
        </IAPanel>
      </div>
    );
  }
}